<template>
  <div class="LmEmailMultiple">
    <input
      v-model="emails"
      v-focus
      class="w-full text-s leading-loose border-b bg-white focus:outline-none appearance-none"
      :class="inputClasses"
      placeholder="Add emails separated by comma"
      @input="clearErrors"
      @focus="clearErrors"
      @keydown.enter="$emit('submit')"
    />
    <span v-if="error" class=" text-xs text-error">{{ errorMessage }}</span>
  </div>
</template>
<script>
import validate from 'validate.js'
import {email as EMAIL_RULE} from '@/components/form/validation-rules'

export default {
  name: 'InvitationForm',
  components: {},
  props: {
    required: {type: Boolean, default: false}
  },
  data() {
    return {
      emails: '',
      errorMessage: null,
      error: false
    }
  },
  computed: {
    inputClasses() {
      return [{'border-error': this.error}, {'border-gray-900': this.active}]
    }
  },
  methods: {
    clearErrors() {
      this.error = false
      this.errorMessage = ''
    },
    // PUBLIC
    setData(emails) {
      if (Array.isArray(emails)) {
        this.emails = emails.join(', ')
      } else if (emails) this.emails = emails
    },
    clear() {
      this.emails = ''
      this.clearErrors()
    },
    setError(message) {
      this.error = true
      this.errorMessage = message
    },
    getEmails() {
      this.clearErrors()
      const emails = this.emails.split(',').map(email => email.trim())
      if (this.required || this.emails.length > 0) {
        if (!emails.some(email => !this.validateEmail(email))) return emails
      } else {
        return this.required ? null : []
      }
    },
    validateEmail(email) {
      console.log('Valid? ', email)
      let v = validate({data: email}, EMAIL_RULE, {fullMessages: false})
      if (v === undefined) {
        return true
      }
      this.error = true
      this.errorMessage = email
        ? email + ' is not a valid email'
        : 'Please enter a valid email'
      return false
    }
  }
}
</script>

<style>
.LmEmailMultiple input:focus {
  outline: none;
  border: none; /* override global */
  border-bottom: 1px solid theme('colors.gray.900');
}
</style>
